import React, { useEffect, useMemo, useState } from 'react'
import './Product.scss'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useStateValue } from '../../store/state';
import { useTranslation } from 'react-i18next';
import Accordion from 'react-bootstrap/Accordion';
import Favourite from '../../assets/images/MyProduct/favorite_border.png'
import FavouriteActive from '../../assets/images/MyProduct/favorite_border_active.png'
import bookmark from '../../assets/images/MyProduct/bookmark_border.png'
import bookmarkActive from '../../assets/images/MyProduct/bookmark_border_active.png'
import Vector from '../../assets/images/MyProduct/Vector.png'
import VectorActive from '../../assets/images/MyProduct/Vector_active.png'
import shoppingBag from '../../assets/images/MyProduct/shopping_bag.png';
import MyReminder_icon from '../../assets/images/MyProduct/MyReminder_icon.png';
import active_MyReminder_icon from '../../assets/images/MyProduct/active_MyReminder_icon.png';
import shoppingBagActive from '../../assets/images/MyProduct/shopping_bag_active.png';
import { GETPRODUCTPLP, PRODUCTLEFTFILTER, PURCHASEPRODUCTLEFTFILTER } from '../../store/PLP/Action'
import Gray_Filter from '../../assets/images/purchase/Gray_Filter.png';

const ProductLeftContent = ({ currentSelection, setCurrentSelection, setPLPData, initialLoad, setInitialLoad, loader, setLoader, type, activeSec, daysSelect, typeSelect, setDaysSelect, setTypeSelect, searchQuery, setAutoLoaders }) => {

    const [{ PRODUCTPLPDATA_FILTER, GENERAL_FILTER_DATA }, dispatch] = useStateValue()
    const { t } = useTranslation()
    const [refreshAPI, setRefreshAPI] = useState(false)
    const [variety, setVariety] = useState([])
    const [currentVariety, setCurrentVariety] = useState("")
    const [A1, setA1] = useState([])
    const [currentA1, setCurrentA1] = useState("")
    const [A2, setA2] = useState([])
    const [currentA2, setCurrentA2] = useState("")
    const [A3, setA3] = useState([])
    const [currentA3, setCurrentA3] = useState("")
    const [autoLoader, setAutoLoader] = useState(1)
    const [purchasedSelection, setPurchasedSelection] = useState("")
    const [mobileCategory, setMobileCategory] = useState("")
    const [applyFilter, setApplyFilter] = useState(false)
    const [activeSection, setActiveSection] = useState('');
    const history = useHistory();

    useEffect(() => {
        setActiveSection(activeSec);
    }, [activeSec]);

    // Image mapping for active and inactive states in sidebar_1
    const images = {
        MyProduct: { inactive: shoppingBag, active: shoppingBagActive },
        MyPurchase: { inactive: Vector, active: VectorActive },
        MyWishlist: { inactive: bookmark, active: bookmarkActive },
        MyReminder: { inactive: MyReminder_icon, active: active_MyReminder_icon },
        MyFavourite: { inactive: Favourite, active: FavouriteActive },
    };

    useEffect(() => {
        const mobileCategoryId = mobileCategory?.id;
        if (window.innerWidth > 912) return
        setCurrentSelection({ ID: mobileCategoryId })
    }, [mobileCategory])

    useEffect(() => {
        setAutoLoaders(1);
        setAutoLoader(1);
        setPLPData([]);
        // setLoader(true);
        setInitialLoad(false);
    }, [daysSelect, currentSelection])

    // Get Product API
    useEffect(() => {
        if (loader) return
        let pageNumber = autoLoader
        if (purchasedSelection != daysSelect) {
            pageNumber = 1
        }
        setPurchasedSelection(daysSelect)
        let TOKEN = localStorage.getItem('token')
        let COMPANYID = localStorage.getItem('companyid')
        let USERID = localStorage.getItem('userid')
        let STOREID = localStorage.getItem('storeid')
        let ID = currentSelection?.ID !== undefined ? currentSelection?.ID : ""
        let SUBID = currentSelection?.subID !== undefined ? currentSelection?.subID : ""
        if (initialLoad && window.innerWidth <= 912 && applyFilter) {
            GETPRODUCTPLP(dispatch, TOKEN, COMPANYID, USERID, STOREID, ID, SUBID, currentVariety, currentA1, currentA2, currentA3, setLoader, pageNumber, variety, A1, A2, A3, daysSelect, searchQuery, typeSelect)
            setApplyFilter(false)
        } else if (!initialLoad) {
            GETPRODUCTPLP(dispatch, TOKEN, COMPANYID, USERID, STOREID, ID, SUBID, currentVariety, currentA1, currentA2, currentA3, setLoader, pageNumber, variety, A1, A2, A3, daysSelect, searchQuery, typeSelect)
            if (window.innerWidth <= 912) {
                setApplyFilter(false);
                // setInitialLoad(true)
            }
        }
    }, [localStorage.getItem('storeid'), currentSelection, variety, currentVariety, currentA1, currentA2, currentA3, refreshAPI, autoLoader, applyFilter, daysSelect])

    // Get category API
    useEffect(() => {
        setCurrentSelection({})
        let COMPANYID = localStorage.getItem('companyid')
        let USERID = localStorage.getItem('userid')
        let STOREID = localStorage.getItem('storeid')
        if (activeSec === 'MyPurchase') {
            PURCHASEPRODUCTLEFTFILTER(dispatch, COMPANYID, USERID, STOREID, daysSelect, typeSelect)
        } else if (activeSec !== 'MyReminder' && activeSec !== 'MyFavourite') {
            PRODUCTLEFTFILTER(dispatch, COMPANYID, USERID, STOREID, daysSelect)
        }
    }, [localStorage.getItem('storeid'), typeSelect])


    // active and inactive states in sidebar_1
    const handleItemClick = (section) => {
        setActiveSection(section);
        setPLPData([]);
        switch (section) {
            case "MyProduct":
                history.push('/myproduct');
                break;
            case "MyPurchase":
                history.push('/mypurchase');
                break;
            case "MyReminder":
                history.push('/myreminder');
                break;
            case "MyFavourite":
                history.push('/myfavourite');
                break;
            default:
                break;
        }
    }

    const LEFTFILTERMEMO = useMemo(() => {
        return <>
            {window.innerWidth > 912 ?
                <Accordion>
                    <div className='category-heading'>{t("category")}</div>
                    <button
                        // className='all_category'
                        className={`all_category ${(currentSelection?.ID === "" && currentSelection?.subID === "") || Object.keys(currentSelection)?.length === 0 ? "selectedFilter" : ""} ${daysSelect ? 'no-color' :"" }`}
                          onClick={() => {
                                    setCurrentSelection({ ID: "", subID: "" });
                                    setDaysSelect(null);
                                }}
                    >
                        {t('All')}
                    </button>
                    {activeSection === 'MyProduct' && (
                        <div>
                            <button
                                className={`all_category ${daysSelect ? 'selectedFilter' : ''}`}
                                onClick={() => {
                                    setCurrentSelection({ ID: "", subID: "" });
                                    setDaysSelect("45");
                                }}
                            >
                                {t('My Recent Purchase')}
                            </button>
                        </div>
                    )}
                    {PRODUCTPLPDATA_FILTER?.length ? (
                        PRODUCTPLPDATA_FILTER.map((data, i) => (
                            <Accordion.Item eventKey={i} key={i}>
                                <Accordion.Header className={`${currentSelection?.id === data?.id && "selectedFilter"}`}>
                                    {t(data?.name)}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        {data?.children_data?.map(childdata => (
                                            <li
                                                className={`${currentSelection?.subID === childdata?.id && "selectedFilter"}`}
                                                 onClick={() => {
                                                              setCurrentSelection({ ID: data?.id, subID: childdata?.id })
                                                              setDaysSelect(null);
                                                }}
                                                key={childdata?.id}
                                            >
                                                {t(childdata?.name)}
                                            </li>
                                        ))}
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))
                    ) : null}

                </Accordion>
                :
                null
            }
        </>
    }, [PRODUCTPLPDATA_FILTER, currentSelection, mobileCategory, GENERAL_FILTER_DATA, variety, A1, A2, A3, t, daysSelect, setDaysSelect])

    const handleSelection = (days, type) => {
        setDaysSelect(days);
        setTypeSelect(type);
    };

    const MOBILELEFTFILTERMEMO = useMemo(() => {
        return <>
            {
                window.innerWidth > 912 ?
                    null
                    :
                    <div className='PRODUCTPLP__MOBILE__SIDEBAR'>
                        <span data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom">
                            <img src={Gray_Filter} alt="" />
                        </span>
                        {activeSec === "MyPurchase" &&
                            <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
                                <div class="offcanvas-header">
                                    <button type="button" class="text-reset" data-bs-dismiss="offcanvas"> <span className='fas fa-angle-left'></span> &nbsp; Back</button>
                                    <div>{t('Last Purchase')}</div>
                                </div>
                                <div class="offcanvas-body small">
                                    <ul className={`clickable ${daysSelect === "0" && typeSelect === "A" ? "active" : ""}`}
                                        onClick={() => {
                                            handleSelection("0", "A")
                                        }}>{t("All")}</ul>
                                    <ul className={`clickable ${daysSelect === "7" && typeSelect === "W" ? "active" : ""}`}
                                        onClick={() => {
                                            handleSelection("7", "W")
                                        }}>{t('Within 1 Week')}</ul>
                                    <ul className={`clickable ${daysSelect === "30" && typeSelect === "W" ? "active" : ""}`}
                                        onClick={() => {
                                            handleSelection("30", "W")
                                        }}>{t('Within 1 Month')}</ul>
                                    <ul className={`clickable ${daysSelect === "31" && typeSelect === "O" ? "active" : ""}`}
                                        onClick={() => {
                                            handleSelection("31", "O")
                                        }}>{t('Over 1 Month')}</ul>
                                    <ul className={`clickable ${daysSelect === "90" && typeSelect === "O" ? "active" : ""}`}
                                        onClick={() => {
                                            handleSelection("90", "O")
                                        }}>{t('Over 3 Month')}</ul>
                                    <div className='offcanvas__buttons' style={{ width: "95%", marginLeft: "10px" }}                                    >
                                        <button style={{ width: "100%", borderRadius: "4px" }} onClick={() => setApplyFilter(true)} className='offcanvas__apply' data-bs-dismiss="offcanvas">Apply</button>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='PRODUCTPLP__MENU'>
                            <span className={`${mobileCategory === "" && "selectedMobileMenu"}`}
                                onClick={() => { setMobileCategory(""); setCurrentSelection({ ID: "", subID: "" }); setDaysSelect(null); setTypeSelect(null); }}>
                                {t('All')}
                            </span>
                            {PRODUCTPLPDATA_FILTER?.map((el, i) => (
                                <span className={`${mobileCategory.id === el.id && "selectedMobileMenu"}`} onClick={() => setMobileCategory(el)} key={i}>{t(el?.name)}</span>
                            ))}
                        </div>
                    </div >
            }
        </>
    }, [PRODUCTPLPDATA_FILTER, currentSelection, mobileCategory, GENERAL_FILTER_DATA, variety, A1, A2, A3, t, daysSelect])


    return (
        <>
            {type === "web" ?
                <>
                    <div className="my_product_sidebar">
                        <div className='sidebar_1'>
                            <div onClick={() => handleItemClick('MyProduct')} className={activeSection === 'MyProduct' ? 'active' : ''}>
                                <span>
                                    <img className='same_size' src={activeSection === 'MyProduct' ? images.MyProduct.active : images.MyProduct.inactive} />
                                </span>
                                <span>
                                    {t("My Product")}
                                </span>
                            </div>
                            <div onClick={() => handleItemClick('MyPurchase')} className={activeSection === 'MyPurchase' ? 'active' : ''}>
                                <span>
                                    <img className='diff_size' src={activeSection === 'MyPurchase' ? images.MyPurchase.active : images.MyPurchase.inactive} />
                                </span>
                                <span>
                                    {t("Recent Purchase")}
                                </span>
                            </div>
                            <div onClick={() => handleItemClick('MyReminder')} className={activeSection === 'MyReminder' ? 'active' : ''}>
                                <span>
                                    <img className='same_size' src={activeSection === 'MyReminder' ? images.MyReminder.active : images.MyReminder.inactive} />
                                </span>
                                <span>
                                    {t("My Reminder")}
                                </span>
                            </div>
                            <div onClick={() => handleItemClick('MyFavourite')} className={activeSection === 'MyFavourite' ? 'active' : ''}>
                                <span>
                                    <img className='same_size' src={activeSection === 'MyFavourite' ? images.MyFavourite.active : images.MyFavourite.inactive} />
                                </span>
                                <span>
                                    {t("My Favourite")}
                                </span>
                            </div>
                        </div>
                        {
                            (activeSection === 'MyProduct' || activeSection === 'MyPurchase') &&
                            <>
                                <hr></hr>
                                <div className='PRODUCTPLP__SIDEBAR'>
                                    {LEFTFILTERMEMO}
                                </div>
                            </>
                        }
                    </div>
                </> : null
            }
            {type === "mobile" ?
                <>
                    <div className='PRODUCTPLP__SIDEBAR'>
                        {MOBILELEFTFILTERMEMO}
                    </div>
                </> : null
            }
        </>
    );
};

export default ProductLeftContent;